<script>

	import { summary } from "./store.js";

</script>

<div class="bg-white border border-dark border-opacity-20 p-4 flex flex-col gap-2 justify-between w-full">
	{#if $summary.total == 0}
		Select something
	{/if}

	{#each $summary.list as key}
		<div class="font-semibold capitalize">{key}</div>
		{#each Object.keys($summary[key]) as title}
			<div class="flex justify-between">
				<span class="capitalize">{title}</span>
				<span>${$summary[key][title] / 100}</span>
			</div>
		{/each}
	{/each}


	{#if $summary.sushiboats > 0}
	<div class="flex justify-between">
		<span class="font-semibold capitalize">Sushiboats</span>
		<span>${$summary.sushiboats / 100}</span>
	</div>
	{/if}

	{#if $summary.total > 0}
	<div class="flex justify-between">
		<span class="font-semibold capitalize">Total</span>
		<span>${$summary.total / 100}</span>
	</div>
	{/if}
</div>